//export const API_BASE_URL = 'https://anilarbulutta-api.kodevi.com.tr';
export const API_BASE_URL = 'https://apianisakla.romanhavalari.com';
//export const API_BASE_URL = 'http://localhost:3001';

export const API_ENDPOINTS = {
  event: {
    getByUserEvent: () => `${API_BASE_URL}/api/events/user`
  },
  events: {
    getByCode: (codeHash) => `${API_BASE_URL}/api/events/code/${codeHash}`,
    getByCodeInfo: (codeHash) => `${API_BASE_URL}/api/events/codeInfo/${codeHash}`,
    getUploads: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/uploads`,
    create: () => `${API_BASE_URL}/api/events`,
    upload: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/upload`,
    update: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}`,
    delete: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}`,
    deleteUpload: (codeHash, fileId) => `${API_BASE_URL}/api/events/${codeHash}/uploads/${fileId}`,
    // Paylaşım endpoint'leri
    share: (eventId) => `${API_BASE_URL}/api/events/${eventId}/share`,
    getShares: (eventId) => `${API_BASE_URL}/api/events/${eventId}/shares`,
    removeShare: (eventId, shareId) => `${API_BASE_URL}/api/events/${eventId}/shares/${shareId}`,
    updateShare: (eventId, shareId) => `${API_BASE_URL}/api/events/${eventId}/shares/${shareId}`,
    // Katılımcı yönetimi endpoint'leri
    getParticipants: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/participants`,
    addParticipant: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/participants`,
    updateParticipant: (codeHash, participantId) => `${API_BASE_URL}/api/events/${codeHash}/participants/${participantId}`,
    deleteParticipant: (codeHash, participantId) => `${API_BASE_URL}/api/events/${codeHash}/participants/${participantId}`,
    exportParticipants: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/participants/export`
  },
  auth: {
    googleAuthUrl: () => `${API_BASE_URL}/api/auth/google/url`,
    googleCallback: () => `${API_BASE_URL}/api/auth/google/callback`,
    googleAuth: () => `${API_BASE_URL}/api/auth/google/auth`,
    checkToken: () => `${API_BASE_URL}/api/auth/google/check-token`,
    refreshToken: () => `${API_BASE_URL}/api/auth/google/refresh-token`
  },
  users: {
    getAll: () => `${API_BASE_URL}/api/users`,
    getDriveFiles: (userId, folderId = 'root', showAllFiles = false) =>
      `${API_BASE_URL}/api/users/${userId}/drive-files?folderId=${folderId}&showAllFiles=${showAllFiles}`,
    deleteFolder: (userId, folderId) =>
      `${API_BASE_URL}/api/users/${userId}/folders/${folderId}`
  },
  contact: {
    getAllMessages: () => `${API_BASE_URL}/api/contact/messages`,
    send: () => `${API_BASE_URL}/api/contact/send`,
  },
  subscription: {
    getAll: () => `${API_BASE_URL}/api/subscription/plans`,
    getUserSubscription: () => `${API_BASE_URL}/api/subscription/user-subscription`,
    cancel: () => `${API_BASE_URL}/api/subscription/cancel`,
    accept: () => `${API_BASE_URL}/api/subscription/accept`,
    remove: () => `${API_BASE_URL}/api/subscription/remove`,
    create: (id) => `${API_BASE_URL}/api/subscription/admin/custom-subscription`,
    payment: {
      init: () => `${API_BASE_URL}/api/subscription/payment/init`,
      callback: () => `${API_BASE_URL}/api/subscription/payment/callback`
    }
  },
  eventTypes: {
    getAll: () => `${API_BASE_URL}/api/event-types`,
    create: () => `${API_BASE_URL}/api/event-types`,
    update: (id) => `${API_BASE_URL}/api/event-types/${id}`,
    delete: (id) => `${API_BASE_URL}/api/event-types/${id}`,
    order: (id) => `${API_BASE_URL}/api/event-types/order/${id}`,
  },
  ai: {
    generate: () => `${API_BASE_URL}/api/ai/generate`
  },
  invitations: {
    getAll: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/invitations`,
    create: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/invitations`,
    update: (codeHash, invitationId) => `${API_BASE_URL}/api/events/${codeHash}/invitations/${invitationId}`,
    delete: (codeHash, invitationId) => `${API_BASE_URL}/api/events/${codeHash}/invitations/${invitationId}`
  },
  plans: {
    getAll: () => `${API_BASE_URL}/api/plans`,
    addFeature: (planId) => `${API_BASE_URL}/api/plans/${planId}/feature`,
    deleteFeature: (planId, featureKey) => `${API_BASE_URL}/api/plans/${planId}/feature/${featureKey}`,
    delete: (planId) => `${API_BASE_URL}/api/plans/${planId}`,
    create: () => `${API_BASE_URL}/api/plans`,
    update: (planId) => `${API_BASE_URL}/api/plans/${planId}`,
    planFileLimit: (codeHash) => `${API_BASE_URL}/api/plans/plan-file-limit/${codeHash}`
  },
  seating: {
    getAll: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/tables`,
    create: (codeHash) => `${API_BASE_URL}/api/events/${codeHash}/tables`,
    update: (codeHash, tableId) => `${API_BASE_URL}/api/events/${codeHash}/tables/${tableId}`,
    planFileLimit: (codeHash) => `${API_BASE_URL}/api/plans/plan-file-limit/${codeHash}`,
    assignSeat: (eventId, seatId) => `${API_BASE_URL}/api/events/${eventId}/seats/${seatId}/assign`,
    unassignSeat: (eventId, seatId) => `${API_BASE_URL}/api/events/${eventId}/seats/${seatId}/unassign`,
  },
  shopier: {
    createPlanAsProduct: (planId) => `${API_BASE_URL}/api/shopier/plans/${planId}/create-product`,
    updatePlanAsProduct: (planId) => `${API_BASE_URL}/api/shopier/plans/${planId}/update-product`,
    createPaymentLink: () => `${API_BASE_URL}/api/shopier/create-payment-link`,
    getProducts: () => `${API_BASE_URL}/api/shopier/products`,
    getOrders: () => `${API_BASE_URL}/api/shopier/orders`
  }
};
